/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MsgList.vue?vue&type=template&id=cb83735e&scoped=true&"
import script from "./MsgList.vue?vue&type=script&lang=js&"
export * from "./MsgList.vue?vue&type=script&lang=js&"
import style0 from "./MsgList.vue?vue&type=style&index=0&id=cb83735e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb83735e",
  null
  
)

export default component.exports